import BASE_URL from '../config/apiConfig';

export const loginUser = async (username, password) => {
  try {
    const response = await fetch(`${BASE_URL}/api/token/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return {
        success: false,
        message: data.detail || 'Invalid credentials'
      };
    }
  } catch (err) {
    console.error('Login error:', err);
    return { success: false, message: 'Server unreachable' };
  }
};


const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    Authorization: `Bearer ${token}`
  };
};

export const uploadDocument = async (formData) => {
  try { 
    const response = await fetch(`${BASE_URL}/api/upload-excel/`, {
      method: 'POST',
      headers: {
        ...getAuthHeaders()
      },
      body: formData
    });

    const data = await response.json();
    console.log(data,"data")
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.detail || 'Upload failed' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};




export const uploadGstEmails = async (formData) => {
  try {
    const auth = getAuthHeaders?.() || {};
    const { ['Content-Type']: _drop, ['content-type']: _drop2, ...safeAuth } = auth;

    const response = await fetch(`${BASE_URL}/api/uploademail/`, {
      method: 'POST',
      headers: {
        ...safeAuth,
        Accept: 'application/json'
      },
      body: formData
    });

    const data = await response.json();
    console.log(data, "data");

    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, data, message: data.error || data.detail || 'Upload failed' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};


export const fetchStates = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/states/`, {
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      }
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: 'Failed to fetch states' };
    }
  } catch (err) {
    return { success: false, message: 'Server error' };
  }
};





export const fetchInvoiceReport = async (filters) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();

    const response = await fetch(`${BASE_URL}/api/non-taxed-invoices/?${queryParams}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Report fetch failed' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};




export const fetchMismatchedInvoices = async (filters) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();

    const response = await fetch(`${BASE_URL}/api/missmatchedinvoices/?${queryParams}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Failed to fetch mismatched invoices' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};



export const updateForm2BInvoice = async (id, invoice_number) => {
  try {
    const response = await fetch(`${BASE_URL}/api/form2b/update-invoice/`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      },
      body: JSON.stringify({
        id: id,
        invoice_number: invoice_number 
      })
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return {
        success: false,
        message: data.error || data.message || 'Update failed'
      };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};


export const updateInvoiceNo = async (id, invoice_number) => {
  try {
    const response = await fetch(`${BASE_URL}/api/update-inv/`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      },
      body: JSON.stringify({
        id: id,
        invoice_number: invoice_number 
      })
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return {
        success: false,
        message: data.error || data.message || 'Update failed'
      };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};











export const fetchSummaryByVendor = async (filters) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();

    const response = await fetch(`${BASE_URL}/api/UnpaidTaxSummary/?${queryParams}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Failed to fetch vendor summary' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};





export const fetchformSummaryByVendor = async (filters) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();

    const response = await fetch(`${BASE_URL}/api/unmatched-form2b-summary/?${queryParams}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Failed to fetch vendor summary' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};




export const fetchInvoiceDetailsByGstid = async (filters) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    console.log(queryParams,"queryParams")
    const response = await fetch(`${BASE_URL}/api/vendorunpaidinvoice/?${queryParams}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Failed to fetch invoice details' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};



export const fetchCummInvoiceDetails = async (filters) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();

    const response = await fetch(`${BASE_URL}/api/vendorcuminvoice/?${queryParams}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });

    const data = await response.json();

    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Failed to fetch unpaid invoice summary' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};


export const fetchCumm2BDetails = async (filters) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();

    const response = await fetch(`${BASE_URL}/api/vendorcum2B/?${queryParams}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });

    const data = await response.json();

    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Failed to fetch unpaid 2B' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};





export const fetchform2bByGstid = async (filters) => {
  try {
      const queryParams = new URLSearchParams(filters).toString();
    const response = await fetch(`${BASE_URL}/api/vendor-unmatched-form2b/?${queryParams}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });
    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Failed to fetch details' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};



export const fetchpaidInvoiceDetailsByGstid = async (filters) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();

    const response = await fetch(`${BASE_URL}/api/vendorpaidinvoice/?${queryParams}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Failed to fetch details' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};








export const fetchPaidSummaryByVendor = async (filters) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();

    const response = await fetch(`${BASE_URL}/api/paidTaxSummary/?${queryParams}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Failed to fetch vendor summary' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};




export const fetchSupplierTypes = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/suppliertypes/`, {
      headers: { ...getAuthHeaders() }
    });
    const data = await response.json();
    return response.ok ? { success: true, data } : { success: false, message: data.message || 'Failed' };
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};










export const updateSupplierTypeInGstMaster = async (gstid, suppliertype) => {
  try {
    const response = await fetch(`${BASE_URL}/api/gstmasters/${gstid}/`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      },
      body: JSON.stringify({ suppliertype })
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Update failed' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};




export const fetchMismatchedSummary = async (state) => {
  try {
    const response = await fetch(`${BASE_URL}/api/mismatchedsummary/?state=${state}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      }
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Failed to fetch summary' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};


export const fetchVendorMismatchDetails = async (filters) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const response = await fetch(`${BASE_URL}/api/vendorinvoicemismatch/?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      }
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Failed to fetch vendor details' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};



export const fetchInvoiceForm2BDetails = async (entryId, invid) => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/InvoiceFormDetailAPIView/?entry_id=${entryId}&invid=${invid}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders()
        }
      }
    );

    const data = await response.json();
    if (response.ok) {
      return data;
    } else {
      return { error: true, message: data.message || 'Failed to fetch detail comparison' };
    }
  } catch (err) {
    return { error: true, message: 'Server unreachable' };
  }
};









export const createState = async (payload) => {
  try {
    const response = await fetch(`${BASE_URL}/api/states/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    if (response.ok) return { success: true, data };
    return { success: false, message: 'Failed to create state' };
  } catch {
    return { success: false, message: 'Server error' };
  }
};

export const updateState = async (id, payload) => {
  try {
    const response = await fetch(`${BASE_URL}/api/states/${id}/`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    if (response.ok) return { success: true, data };
    return { success: false, message: 'Failed to update state' };
  } catch {
    return { success: false, message: 'Server error' };
  }
};



export const deleteState = async (id) => {
  try {
    const response = await fetch(`${BASE_URL}/api/states/${id}/`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      }
    });
    if (response.ok) return { success: true };
    return { success: false, message: 'Failed to delete state' };
  } catch {
    return { success: false, message: 'Server error' };
  }
};






export const fetchGstMasters = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/gstmasters/`, {
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      }
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: 'Failed to fetch GST Masters' };
    }
  } catch (err) {
    return { success: false, message: 'Server error' };
  }
};


export const createGstMaster = async (payload) => {
  try {
    const response = await fetch(`${BASE_URL}/api/gstmasters/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      },
      body: JSON.stringify(payload)
    });

    if (response.ok) {
      return { success: true };
    } else {
      const errData = await response.json();
      return { success: false, message: errData.detail || 'Failed to create GST Master' };
    }
  } catch (err) {
    return { success: false, message: 'Server error' };
  }
};


export const updateGstMaster = async (id, payload) => {
  try {
    console.log(id,'id')
    const response = await fetch(`${BASE_URL}/api/gstmasters/${id}/`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      },
      body: JSON.stringify(payload)
    });

    if (response.ok) {
      return { success: true };
    } else {
      const errData = await response.json();
      return { success: false, message: errData.detail || 'Failed to update GST Master' };
    }
  } catch (err) {
    return { success: false, message: 'Server error' };
  }
};


export const deleteGstMaster = async (id) => {
  try {
    const response = await fetch(`${BASE_URL}/api/gstmasters/${id}/`, {
      method: 'DELETE',
      headers: {
        ...getAuthHeaders()
      }
    });

    if (response.ok) {
      return { success: true };
    } else {
      const errData = await response.json();
      return { success: false, message: errData.detail || 'Failed to delete GST Master' };
    }
  } catch (err) {
    return { success: false, message: 'Server error' };
  }
};






export const createSupplierType = async (payload) => {
  try {
    const response = await fetch(`${BASE_URL}/api/suppliertypes/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      },
      body: JSON.stringify(payload)
    });
    if (response.ok) {
      return { success: true };
    } else {
      const data = await response.json();
      return { success: false, message: data.detail || 'Failed to create supplier type' };
    }
  } catch (err) {
    return { success: false, message: 'Server error' };
  }
};



export const updateSupplierType = async (id, payload) => {
  try {
    const response = await fetch(`${BASE_URL}/api/suppliertypes/${id}/`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      },
      body: JSON.stringify(payload)
    });
    if (response.ok) {
      return { success: true };
    } else {
      const data = await response.json();
      return { success: false, message: data.detail || 'Failed to update supplier type' };
    }
  } catch (err) {
    return { success: false, message: 'Server error' };
  }
};


export const deleteSupplierType = async (id) => {
  try {
    const response = await fetch(`${BASE_URL}/api/suppliertypes/${id}/`, {
      method: 'DELETE',
      headers: {
        ...getAuthHeaders()
      }
    });
    if (response.ok) {
      return { success: true };
    } else {
      const data = await response.json();
      return { success: false, message: data.detail || 'Failed to delete supplier type' };
    }
  } catch (err) {
    return { success: false, message: 'Server error' };
  }
};




export const fetchUsers = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/users/`, {
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      }
    });
    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: 'Failed to fetch users' };
    }
  } catch (err) {
    return { success: false, message: 'Server error' };
  }
};


export const createUser = async (userData) => {
  try {
    const response = await fetch(`${BASE_URL}/api/users/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      },
      body: JSON.stringify(userData)
    });
    if (response.ok) {
      return { success: true };
    } else {
      const err = await response.json();
      return { success: false, message: err.detail || 'Failed to create user' };
    }
  } catch (err) {
    return { success: false, message: 'Server error' };
  }
};


export const updateUser = async (id, userData) => {
  try {
    const response = await fetch(`${BASE_URL}/api/users/${id}/`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      },
      body: JSON.stringify(userData)
    });
    if (response.ok) {
      return { success: true };
    } else {
      const err = await response.json();
      return { success: false, message: err.detail || 'Failed to update user' };
    }
  } catch (err) {
    return { success: false, message: 'Server error' };
  }
};


export const deleteUser = async (id) => {
  try {
    const response = await fetch(`${BASE_URL}/api/users/${id}/`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      }
    });
    if (response.ok) {
      return { success: true };
    } else {
      return { success: false, message: 'Failed to delete user' };
    }
  } catch (err) {
    return { success: false, message: 'Server error' };
  }
};



export const fetchRoles = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/role/`, {
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() }
    });
    const data = await response.json();
    return response.ok ? { success: true, data } : { success: false, message: 'Failed to fetch roles' };
  } catch {
    return { success: false, message: 'Server error' };
  }
};

export const createRole = async (role) => {
  try {
    const response = await fetch(`${BASE_URL}/api/role/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify(role)
    });
    return response.ok ? { success: true } : { success: false, message: 'Failed to create role' };
  } catch {
    return { success: false, message: 'Server error' };
  }
};

export const updateRole = async (id, role) => {
  try {
    const response = await fetch(`${BASE_URL}/api/role/${id}/`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify(role)
    });
    return response.ok ? { success: true } : { success: false, message: 'Failed to update role' };
  } catch {
    return { success: false, message: 'Server error' };
  }
};

export const deleteRole = async (id) => {
  try {
    const response = await fetch(`${BASE_URL}/api/role/${id}/`, {
      method: 'DELETE',
      headers: { ...getAuthHeaders() }
    });
    return response.ok ? { success: true } : { success: false, message: 'Failed to delete role' };
  } catch {
    return { success: false, message: 'Server error' };
  }
};



export const fetchUserInfo = async () => {
  try {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${BASE_URL}/api/userinfo/`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: 'Unauthorized' };
    }
  } catch (error) {
    return { success: false, message: 'Server error' };
  }
};


export const markInvoiceAsRemoved = async (invoice_id,reason) => {
  try {
    const token = localStorage.getItem('authToken');

    const response = await fetch(`${BASE_URL}/api/invoice/remove/`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ invoice_id,reason })
    });

    const data = await response.json();

    if (response.ok) {
      return { success: true, message: data.message };
    } else {
      return { success: false, message: data.error || 'Failed to mark invoice as removed' };
    }
  } catch (err) {
    return { success: false, message: 'Failed to mark invoice as removed' };
  }
};



export const markForm2BAsRemoved = async (entry_id,reason) => {
  try {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${BASE_URL}/api/form2b/remove/`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ entry_id,reason }),
    });

    if (response.ok) {
      const data = await response.json();
      return { success: true, message: data.message };
    } else {
      const error = await response.json();
      return { success: false, message: error?.error || 'Failed to remove Form2B entry' };
    }
  } catch (err) {
    return { success: false, message: 'Something went wrong' };
  }
};



export const markDebitAsRemoved = async (invoice_id) => {
  try {
    const token = localStorage.getItem('authToken');

    const response = await fetch(`${BASE_URL}/api/debit/remove/`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ invoice_id })
    });

    const data = await response.json();

    if (response.ok) {
      return { success: true, message: data.message };
    } else {
      return { success: false, message: data.error || 'Failed to mark invoice as removed' };
    }
  } catch (err) {
    return { success: false, message: 'Failed to mark invoice as removed' };
  }
};










export const sendVendorUnpaidInvoiceMail = async (gstid) => {
  try {
    const token = localStorage.getItem("authToken");
    const res = await fetch(`${BASE_URL}/api/unpaid-invoices-mail/?gstid=${gstid}&send_email=true`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    const data = await res.json();

    if (!res.ok) {
      console.error("Backend Error:", data);
      return { success: false, message: data.error || "Failed to send email" };
    }

    return { success: true, message: data.message };
  } catch (error) {
    console.error("Fetch Error:", error);  
    return { success: false, message: "An error occurred while sending email." };
  }
};




export const fetchDebitSummaryByVendor = async (filters) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();

    const response = await fetch(`${BASE_URL}/api/UnpaiddebitnoteSummary/?${queryParams}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Failed to fetch vendor summary' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};



export const fetchDebitDetailsByGstid = async (gstid) => {
  try {
    const response = await fetch(`${BASE_URL}/api/vendorunpaiddebit_note/?gstid=${gstid}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });
    const data = await response.json();
    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Failed to fetch details' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};




export const matchInvoices = async (state) => {
  const token = localStorage.getItem('authToken');

  try {
    const response = await fetch(`${BASE_URL}/api/match-invoices-form2b/?state=${state}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (!response.ok) throw new Error(data.error || 'Invoice matching failed');
    return { success: true, message: data.message };
  } catch (err) {
    return { success: false, message: err.message };
  }
};



export const fetchInvoiceAuditLogs = async (filters) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();

    const response = await fetch(`${BASE_URL}/api/invoice-audit-logs/?${queryParams}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });

    const data = await response.json();

    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Failed to fetch audit logs' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};



export const fetchForm2BAuditLogs = async (filters) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();

    const response = await fetch(`${BASE_URL}/api/form-audit-logs/?${queryParams}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });

    const data = await response.json();

    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || 'Failed to fetch audit logs' };
    }
  } catch (err) {
    return { success: false, message: 'Server unreachable' };
  }
};




export const fetchForm2BDetailsByAuditLogId = async (auditLogId) => {
  try {

    const response = await fetch(`${BASE_URL}/api/api/form2b-audit-details/${auditLogId}`, {
    // const response = await fetch(`${BASE_URL}/api/form2b-audit-details/${auditLogId}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    return { success: false, message: "Server error" };
  }
};



export const fetchInvoiceDetailsByAuditLogId = async (auditLogId) => {
  try {
    const response = await fetch(`${BASE_URL}/api/api/invoice-audit-details/${auditLogId}`, {
      method: 'GET',
      headers: {
        ...getAuthHeaders()
      }
    });

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error("Error fetching invoice details:", error);
    return { success: false, message: "Server error" };
  }
};
